"use client";

import { FC, useContext } from "react";
import classNames from "classnames";

import { HeaderContext, IHeaderContext } from "context";

import { LanguageToggle } from "components/molecules/LanguageToggle/LanguageToggle";
import { Hamburger } from "components/atoms/Hamburger/Hamburger";

import { IDatoGeneralMeta } from "@types";
import { CBButton } from "components/InlineBlocks/CBButton";
import { NavbarPrimary } from "./NavbarPrimary";
import s from "./Navbar.module.scss";

interface Props {
  mainNavbarItems: IDatoGeneralMeta["mainNavigation"];
  navCta: IDatoGeneralMeta["navCta"];
}

export const Navbar: FC<Props> = ({ mainNavbarItems, navCta }) => {
  const { mobileMenuOpen } = useContext(HeaderContext) as IHeaderContext;

  return (
    <div
      className={classNames(s.Navbar, {
        [s.IsOpen]: mobileMenuOpen,
      })}
    >
      <div className={s.Inner}>
        <NavbarPrimary mainNavbarItems={mainNavbarItems} navCta={navCta} />
      </div>
      <div className={s.Actions}>
        {navCta && (
          <div className={s.Cta}>
            <CBButton {...navCta} />
          </div>
        )}
        <LanguageToggle />
        <Hamburger />
      </div>
    </div>
  );
};
